const selectors = {
  ITEM_CLASS: '.js-hero-interactive-item',
};

const attributes = {
  ACTIVE_ITEM: '--active-item',
};

export class HeroInteractive extends HTMLElement {
  #abortController = new AbortController();

  connectedCallback() {
    this.#abortController = new AbortController();

    const { signal } = this.#abortController;
    const items = this.querySelectorAll(selectors.ITEM_CLASS);

    if (!items.length) return;

    items.forEach((item, index) => {
      const handleActivate = () => this.style.setProperty(attributes.ACTIVE_ITEM, String(index));

      item.addEventListener('focusin', handleActivate, { signal });
      item.addEventListener('mouseenter', handleActivate, { signal });
    });
  }

  disconnectedCallback() {
    this.#abortController.abort();
  }
}

if (!customElements.get('hero-interactive')) {
  customElements.define('hero-interactive', HeroInteractive);
}
